// extracted by mini-css-extract-plugin
export var externalLink = "_cg-0";
export var internalLinkLabel = "_cg-1";